import { useCallback } from "react";
import { useUserDataContext } from "../user_data_context";
import { deletePushToken } from "../push/push_api";
import { clearStoredFcmToken, getStoredFcmToken } from "../push/token_store";
import { clearPrivateStorage } from "../common/utils/clear_private_storage";
import { describeError } from "../common/utils/error_message";

export const useLogout = () => {
	const { fetchUserData } = useUserDataContext();

	return useCallback(async () => {
		const pushToken = getStoredFcmToken();
		try {
			if (pushToken) await deletePushToken(pushToken);
		} catch (e) {
			console.warn("Failed to delete push token:", describeError(e));
		} finally {
			clearStoredFcmToken();
			clearPrivateStorage();
			localStorage.removeItem("access_token");
			fetchUserData();
		}
	}, [fetchUserData]);
};
